var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBriefCase(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 155.41 122.19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#505050;}.cls-2{fill:#9ca5ad;}.cls-3{fill:#0c0c0c;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "vectors"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M0,18.2v96.19a7.8,7.8,0,0,0,7.8,7.8H147.61a7.8,7.8,0,0,0,7.8-7.8V18.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M103.2,52h-52a2.59,2.59,0,0,1-2.6-2.6v-39A10.4,10.4,0,0,1,59,0H95.4a10.4,10.4,0,0,1,10.4,10.4v39A2.59,2.59,0,0,1,103.2,52ZM53.81,46.8H100.6V10.4a5.2,5.2,0,0,0-5.2-5.2H59a5.2,5.2,0,0,0-5.2,5.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M121.76,65H33.65a13,13,0,0,1-11.36-6.68L0,18.2H155.41L133.12,58.31A13,13,0,0,1,121.76,65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M87.6,49.4H66.81A7.8,7.8,0,0,0,59,57.2V65h9.1V78a5.19,5.19,0,0,0,5.19,5.2h7.8A5.2,5.2,0,0,0,86.3,78V65h9.1V57.2A7.8,7.8,0,0,0,87.6,49.4ZM81.1,76.7A1.3,1.3,0,0,1,79.8,78H74.6a1.3,1.3,0,0,1-1.3-1.3V65h7.8Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefCase);
export default __webpack_public_path__ + "static/media/brief_case.a881db234acc3e7115b9e78d79b2aa69.svg";
export { ForwardRef as ReactComponent };